// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { safeStorage } from '@/lib/safeStorage';

const SUPABASE_URL = "https://edyzytvoywcegqfuctto.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVkeXp5dHZveXdjZWdxZnVjdHRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMyODQ2MDksImV4cCI6MjA2ODg2MDYwOX0.eIzjiu4CKdVleob65WWV4LbD6sBNrDXf9aBZxQzM868";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeStorage as any,
    persistSession: true,
    autoRefreshToken: true,
  }
});